import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from '@gravity-ui/icons';
import {
  ALL_CAMERA_STATUS_GROUPS,
  CAMERA_STATUS_GROUPS,
  countCamerasByStatusGroup,
} from '../../utils/cameraStatusFilter';
import './CameraStatusFilter.css';

/**
 * ТЗ V5 №14: кнопка «Состояние камер» и панель чекбоксов. Изменение
 * применяется и сохраняется сразу; камеры не запускаются и не
 * останавливаются. Счётчики — по всей локации до фильтра.
 */
const CameraStatusFilter = ({ cameras, shown, selected, onChange }) => {
  const [open, setOpen] = useState(false);
  const counts = countCamerasByStatusGroup(cameras);
  const selectedSet = new Set(selected);
  const allSelected = ALL_CAMERA_STATUS_GROUPS.every((id) => selectedSet.has(id));
  const knownSelected = ALL_CAMERA_STATUS_GROUPS.filter((id) => selectedSet.has(id)).length;

  const toggle = (id) => {
    if (selectedSet.has(id)) onChange(selected.filter((item) => item !== id));
    else onChange([...selected, id]);
  };

  return (
    <div className="csf">
      <button
        type="button"
        className="csf-toggle"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        Состояние камер
        {!allSelected && <span className="csf-toggle-count">{`Выбрано ${knownSelected}`}</span>}
        {open ? <ChevronUp width={16} height={16} aria-hidden /> : <ChevronDown width={16} height={16} aria-hidden />}
      </button>
      {open && (
        <div className="csf-panel">
          <div className="csf-options">
            {CAMERA_STATUS_GROUPS.map((group) => (
              <label key={group.id} className="csf-option">
                <input
                  type="checkbox"
                  checked={selectedSet.has(group.id)}
                  onChange={() => toggle(group.id)}
                />
                <span>{group.label}</span>
                <span className="csf-option-count">{counts[group.id]}</span>
              </label>
            ))}
          </div>
          <div className="csf-actions">
            <button
              type="button"
              className="csf-link"
              disabled={allSelected}
              onClick={() => onChange(ALL_CAMERA_STATUS_GROUPS)}
            >
              Выбрать все
            </button>
            <button
              type="button"
              className="csf-link"
              disabled={selected.length === 0}
              onClick={() => onChange([])}
            >
              Снять все
            </button>
          </div>
        </div>
      )}
      <span className="csf-summary">{`Показано ${shown} из ${cameras.length}`}</span>
    </div>
  );
};

export default CameraStatusFilter;
